/**
 * system-notification.ts — Hiện thông báo hệ điều hành cho tin nhắn mới.
 *
 * `new Notification()` chỉ chạy trên máy tính; Android Chrome / PWA đã cài ném "Illegal constructor" và chỉ chấp nhận
 * `registration.showNotification()`. Nên: có service worker → dùng nó (bấm thông báo do sw.js xử lý, gửi `ecdp:open-url`
 * về trang); không có (bản dev, trình duyệt cũ) → `new Notification` như trước. Mọi lỗi đều nuốt: thông báo chỉ là lớp báo thêm.
 */
export const OPEN_URL_MESSAGE = 'ecdp:open-url'

/** Đường dẫn trong ứng dụng cho một hội thoại. */
export const conversationUrl = (conversationId: string) => `/conversations/${conversationId}`

/** Chỉ nhận đường dẫn cùng nguồn ("/…"), loại "//host" và địa chỉ ngoài. Dùng cho tin nhắn từ service worker. */
export function safeInAppUrl(raw: unknown): string | null {
  return typeof raw === 'string' && raw.startsWith('/') && !raw.startsWith('//') ? raw : null
}

export async function showSystemNotification(
  title: string,
  opts: { body: string; tag: string; url: string; onClick?: () => void },
): Promise<void> {
  const icon = '/icons/icon-192.png'
  try {
    const reg = await navigator.serviceWorker?.getRegistration?.()
    if (reg?.showNotification) {
      await reg.showNotification(title, { body: opts.body, tag: opts.tag, icon, badge: '/favicon.png', data: { url: opts.url } })
      return
    }
  } catch { /* rơi xuống Notification trực tiếp */ }
  try {
    const n = new Notification(title, { body: opts.body, tag: opts.tag, icon })
    n.onclick = () => {
      window.focus()
      opts.onClick?.()
      n.close()
    }
  } catch { /* trình duyệt không cho tạo Notification trực tiếp */ }
}
